export default {"src":"/_next/static/media/logotype-visit-original-sweden.32cc3ea2.svg","height":45,"width":208,"blurWidth":0,"blurHeight":0};